








import { Component, Vue, Prop } from 'nuxt-property-decorator';

import { IconArrowLeft } from '@/icons';

@Component({
  components: {
    IconArrowLeft,
  },
})
export default class ButtonBackToParentPage extends Vue {
  @Prop({ type: String, required: true })
  to!: string;

  @Prop(String)
  text!: string;

  get linkText () {
    return this.text ? `Gå till ${this.text}` : 'Tillbaka';
  }
}
